import { createFileRoute } from "@tanstack/react-router";
import ThankYouVibe from "@/pages/ThankYouVibe";
export const Route = createFileRoute("/thankyou-vibe")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Thank You — We Received Your Request | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thank you for reaching out to Neuro Wellness TMS Centers of America. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:title",
          content: "Thank You — We Received Your Request | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thank you for reaching out to Neuro Wellness TMS Centers of America. A member of our clinical team will contact you within one business day.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thankyou-vibe",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thankyou-vibe",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouVibe />;
}
